import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import { Formik } from 'formik'
import { editEndpointList } from '../actions/endpoints'
import { fetchEndpointIfNeeded as ftch } from '../actions/fetch'
import MappingFieldTable from './MappingFieldTable'
import ScheduleForm from './scheduleForm'
// import Subtask from './utilities/tabs/Subtask';
// import IntegrationFilterForm from './integrationFilterForm'
import JSONForm from './utilities/JSONForm'
import NavItem from './utilities/NavItem'
import NavContent from './utilities/NavContent'
// import FormButtonPanel from './utilities/FormButtonPanel'
import { CSSTransition } from "react-transition-group"
import { showMessage } from '../actions/messageBox'
import moment from 'moment'
import 'moment-timezone'
import JsonViewer from './utilities/tabs/jsonViewer'
import JsonTableViewer from './utilities/tabs/jsontable'
import JoblogJsonTableViwer from './utilities/tabs/JoblogJsonTable'


class IntegrationMappingForm extends Component {
    constructor(props) {
        super(props)

        /**
         * Initialize the Refs, so we can remotely call their submit functions
         * when Save button is clicked
         */
        this.fieldMappingRef = null
        this.scheduleRef = null
        this.handleSubmitClick = this.handleSubmitClick.bind(this)
        

        this.state = {
            integrationForm: this.props.list,
            scheduleForm: this.props.schedule,
            endpoints: this.props.endpoints,
            fieldMappingLocked: false,
            integrationJSON: "",
            updateAudit: false,
            updateJoblog: false
        }

    }

    componentWillReceiveProps(nextProps) {
        let newIntegrationValues = this.state.integrationForm === undefined && nextProps.list !== undefined ? nextProps.list : this.state.integrationForm
        let newScheduleValues = this.state.scheduleForm === undefined && nextProps.schedule !== undefined ? nextProps.schedule : this.state.scheduleForm

        this.setState({
            integrationForm: newIntegrationValues,
            scheduleForm: newScheduleValues,
        })
    }

    componentDidMount() {
        this.props.dispatch(ftch(1, true))
        this.props.dispatch(ftch(2, true))
        this.props.dispatch(ftch(12, true))
        this.props.dispatch(ftch(15, true))
        this.props.dispatch(ftch(17, true))
        this.props.dispatch(ftch(7, true))
    }

    componentDidUpdate() {
        
        if (this.state.updateAudit) {
            this.props.dispatch(ftch(15, true)).then(respObj => {
                this.setState({
                    updateAudit: false
                })
                return respObj
            })

        }

        if (this.state.updateJoblog) {
            this.props.dispatch(ftch(17, true)).then(respObj => {
                this.setState({
                    updateJoblog: false
                })
                return respObj
            })

        }

    }

    handleSubmitClick() {
        this.setState({
            updateAudit: true,
            updateJoblog: true
        })
    }

    render() {
        let {
            list,
            mappingId,
            schedule,
            endpointName,
            endpointId,
            // isFetching,
            integrationOptions,
            integrationOptionsJSONStr,
            integrationTransformations,
            integrationTransformationsJSONStr,
            accessToken,
            dispatch,
            endpoints,
            isUserAdmin
        } = this.props

        //Define Variables for audit List
        let getAuditList
        let getUserList
        let getTaskList
        let getDatasourceList
        let getDatasourcemappingList
        let getJoblogList


        //Get List from endpoints
        for (let n in endpoints) {
            if (endpoints[n].name === "audits") {
                getAuditList = endpoints[n].list
            } else if (endpoints[n].name === "users") {
                getUserList = endpoints[n].list
            } else if (endpoints[n].name === "tasks") {
                getTaskList = endpoints[n].list
            } else if (endpoints[n].name === "datasourcemappings") {
                getDatasourceList = endpoints[n].list
            } else if (endpoints[n].name === "datasourcemappingfields") {
                getDatasourcemappingList = endpoints[n].list
            } else if (endpoints[n].name === "joblogs"){
                getJoblogList = endpoints[n].list
            }
        }


        let getAllMappingField = []

        let getId = list && list.id


        //Filter List to based on mapping IDS
        let filterTaskList = getTaskList.filter(list => list.id === getId);
        let filterJoblogList = getJoblogList.filter(jlist => jlist.task_id === getId)

        let getFilteredTaskOptions = filterTaskList && filterTaskList[0] ? JSON.parse(filterTaskList[0].options) : null;
        let getDatasourcemappingId = getFilteredTaskOptions && getFilteredTaskOptions.datasourcemapping_id ? getFilteredTaskOptions.datasourcemapping_id : 0;


        let getTaskFilterList = getAuditList.filter(list => list.document_id == mappingId && list.document_type === "task")

        //Get List where there is options 
        // let a = getTaskFilterList && getTaskFilterList.forEach(function (e) {
        //     let b = e && JSON.parse(e.audit)
        //     b.forEach(function (a) {
        //         let c = a && a.path
        //         if (c && c[0] === "options") {

        //             getAllMappingField.push(e)
        //         }

        //     })

        // })

        //Get DatasourceList based on Datasourcemapping ID
        let filterDatasourceList = getDatasourceList.filter(list => list.id === getDatasourcemappingId)

        //Get DatasourcemappingFieldId from Filtered Datasource List
        let getDatasourcemappingFieldId = filterDatasourceList[0] && filterDatasourceList[0].id

        //Filter Datasourcemapping List based on DatasourcemappingField Id
        let filterDatasourcemappingList = getDatasourcemappingList.filter(list => list.mapping_id === getDatasourcemappingFieldId)


        //Map the list by IDS
        let filterDatasourcemappingListId = filterDatasourcemappingList.map(({ id }) => id)

        //Loop each id on list to get the datasourcemappingfield list
        let array = filterDatasourcemappingListId.map(function (e) {
            let f = getAuditList.filter(list => list.document_id == e && list.document_type === "datasourcemappingfield");

            f.forEach(function (element) {

                getAllMappingField.push(element)
            })
        });

        //Sort the list by date (recent)
        let sortMappingFieldAuditList = getAllMappingField.sort(function (a, b) {
            return new Date(b.updated_at) - new Date(a.updated_at)
        })

        let sortJoblogAuditList = filterJoblogList.sort(function (a, b) {
            return new Date(b.updated_at) - new Date(a.updated_at)
        })


        let IntegrationAuditForm
        let JoblogAuditForm
        let IntegrationAuditFormv2

        //Assign the List to the json table viwer
        IntegrationAuditForm = (
            <JsonTableViewer value={sortMappingFieldAuditList} user={getUserList} endpoint={"Mapping"} />
        );

        IntegrationAuditFormv2 = (
            <JsonTableViewer value={sortMappingFieldAuditList} user={getUserList} />
        );
        JoblogAuditForm = (
            < JoblogJsonTableViwer value={sortJoblogAuditList} user={getUserList} />
        );

        let {
            integrationForm,
            scheduleForm
        } = this.state

        // Initialize an empty object
        let objProp = {}

        // Initial values
        let initVal = Object.assign({}, {
            schedule: { ...scheduleForm },
            integrationOptions: integrationOptions,
            integrationOptionsJSONStr: integrationOptionsJSONStr,
            integrationTransformations: integrationTransformations,
            integrationTransformationsJSONStr: integrationTransformationsJSONStr
        }, objProp)

        // Format the dates correctly using moment
        if (initVal.schedule && initVal.schedule.start_date && schedule)
            initVal.schedule.start_date = moment(schedule.start_date, 'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)').tz("UTC").format("YYYY-MM-DD")
        if (initVal.schedule && initVal.schedule.end_date && schedule)
            initVal.schedule.end_date = moment(schedule.end_date, 'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)').tz("UTC").format("YYYY-MM-DD")
            

        // let filters = ( list && list.options && list.options.includes( 'filters') ) ?
        //     JSON.parse( list.options ).filters: ''

        initVal = integrationForm !== undefined ?
            Object.assign({}, initVal, {
                name: integrationForm.name,
                description: integrationForm.description,
                handler: integrationForm.handler,
                status: integrationForm.status,
                list: integrationForm
            }) : initVal


        return (
            <div id="working-area-content">
                <div className="">
                    <Formik
                        enableReinitialize
                        initialValues={initVal}
                        validate={(values) => {

                            let errors = {}
                            let numericRestriction = /^[0-9]+$/

                            if (values.schedule.start_date === "Invalid date") {
                                if (!errors.schedule) errors.schedule = {}
                                errors.schedule.start_date = "This field is required"
                            }
                            if (values.schedule.end_date === "Invalid date") {
                                if (!errors.schedule) errors.schedule = {}
                                errors.schedule.end_date = "This field is required"
                            }
                            if (values.schedule.start_time === "Invalid date") {
                                if (!errors.schedule) errors.schedule = {}
                                errors.schedule.start_time = "This field is required"
                            }
                            if (!values.schedule.frequency_id) {
                                if (!errors.schedule) errors.schedule = {}
                                errors.schedule.frequency_id = "This field is required"
                            }
                            if (!numericRestriction.test(values.schedule.queue_no)) {
                                if (!errors.schedule) errors.schedule = {}
                                errors.schedule.queue_no = "This field must be a valid number"
                            }
                            if ((values.schedule.start_date !== "Invalid date" && values.schedule.end_date !== "Invalid date") &&
                                (moment(values.schedule.end_date).isBefore(values.schedule.start_date))
                            ) {
                                if (!errors.schedule) errors.schedule = {}
                                errors.schedule.start_date = "Date must be  before end date"
                                errors.schedule.end_date = "Date must be after start date"
                            }

                            return errors
                        }}
                        onSubmit={(values) => {
                            console.log('Values',values)
                            //Created by auto update located here
                            let integrationForm = {
                                id: list.id,
                                options: values.integrationOptionsJSONStr,
                                transformations: values.integrationTransformationsJSONStr
                                //updated_by:21
                            }
                            let scheduleForm = {
                                ...values.schedule
                            }


                            let promiseArray = []
                            let errorArray = []
                            // THIS IS FOR CRETEDBY
                            // console.log("integrationForm",integrationForm)
                            // console.log("scheduleForm",scheduleForm)
                            promiseArray.push(
                                dispatch(editEndpointList(1, 'tasks', accessToken, integrationForm, "PATCH")).then(respObj => {

                                    if (!respObj.response.ok) {
                                        errorArray.push("There were errors when saving the integration options")
                                    }
                                    return respObj
                                })
                            )

                            promiseArray.push(
                                dispatch(editEndpointList(2, "schedules", accessToken, scheduleForm)).then(respObj => {
                                    if (!respObj.response.ok) {
                                        errorArray.push("There were errors when saving the schedule")
                                    }
                                    return respObj
                                })
                            )

                            promiseArray.push(
                                this.fieldMappingRef.handleSubmit().then(respObj => {
                                    if (!respObj.response.ok) {
                                        errorArray.push("There were errors when saving the fieldmappings")
                                    }
                                    return respObj
                                })
                            )

                            Promise.all(promiseArray).then(respObj => {

                                this.props.dispatch(ftch(15, true))

                                let errorResponses = respObj.find(obj => !obj.response.ok)
                                if (!errorResponses) {
                                    this.props.dispatch(
                                        showMessage({
                                            type: "success",
                                            title: "Saved",
                                            message: "Integration options successfully saved"
                                        })
                                    )
                                } else {
                                    let errorMessage = errorArray.join('\n')
                                    this.props.dispatch(
                                        showMessage({
                                            type: "error",
                                            title: "Error",
                                            message: errorMessage
                                        })
                                    )
                                }
                                this.setState({ fieldMappingLocked: false })
                            })
                            //dispatch(editEndpointList(12,'datasourcemappingfields',accessToken,values.mappingForm))
                            // values.mappingForm.forEach(obj => {
                            //    dispatch(editEndpointList(12,'datasourcemappingfields',accessToken,obj)).then(responseObj=>console.table(responseObj.json))
                            //}) 
                        }}
                        render={({
                            handleSubmit,
                            handleChange,
                            values,
                            errors
                        }) => {
                            /* 
                            let IntFilterForm = <IntegrationFilterForm 
                                    filters={filters}
                                    mappingId={mappingId}
                                    list={list}
                                    endpointId={endpointId}
                                    endpointName={endpointName}
                                    isFetching={isFetching}
                                /> 
                            */



                            let FldMapping = <MappingFieldTable
                                mappingId={mappingId}
                                setRef={(node) => { this.fieldMappingRef = node }}
                                locked={this.state.fieldMappingLocked}
                                handleSubmitClick={this.handleSubmitClick}
                            />

                            let Endpoints = this.props.endpoints

                            let getUserList = Endpoints.find(epn => epn.name === "users")

                            let SchedForm = <ScheduleForm
                                schedule={values.schedule}
                                endpoints={getUserList}
                                errors={errors.schedule}
                                onChange={handleChange}
                                setRef={(node) => { this.scheduleRef = node }}
                                allowActivate={values.status === 1}
                            />

                            let IntegrationOptionForm = (
                                <div className="margined fieldmapping-standalone">
                                    <div className="row fieldmap-table-header no-gutters">
                                        <div className="col-12 field-mapping-header-label-wrapper">
                                            <div className="row fieldmap-table-toolbar py-1 clearfix no-gutters">
                                                <div className="ml-3 float-left">
                                                    <button className="btn" type="submit" >
                                                        <i className="fa fa-save fa-fw"></i> Apply
                                                </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>                        
                                    <JSONForm
                                        type="text"
                                        name="integrationOptionsJSONStr"
                                        id={integrationOptionsJSONStr}
                                        onChange={handleChange}
                                        value={values.integrationOptionsJSONStr}
                                        label="Options"
                                        allowedTypes={["Text", "TextArea", "Password","Boolean","Object"]}
                                        dispatch={dispatch}
                                        hiddenFields={["type", "datasourcemapping_id", "schedule_id"]}
                                    />
                                </div>
                            )

                            let IntegrationOptionForm2 = (
                                <div className="margined fieldmapping-standalone">
                                    <div className="row fieldmap-table-header no-gutters">
                                        <div className="col-12 field-mapping-header-label-wrapper">
                                            <div className="row fieldmap-table-toolbar py-1 clearfix no-gutters">
                                                <div className="ml-3 float-left">
                                                    <button className="btn" type="submit" >
                                                        <i className="fa fa-save fa-fw"></i> Apply
                                                </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>                        
                                    <JSONForm
                                        type="text"
                                        name="integrationOptionsJSONStr"
                                        id={integrationOptionsJSONStr}
                                        onChange={handleChange}
                                        value={values.integrationOptionsJSONStr}
                                        label="Options"
                                        allowedTypes={["UserAdmin"]}
                                        dispatch={dispatch}
                                        hiddenFields={["type", "datasourcemapping_id", "schedule_id"]}
                                    />
                                </div>
                            )

                            let IntegrationTransformationForm  = (
                                <div className="margined fieldmapping-standalone">
                                    <div className="row fieldmap-table-header no-gutters">
                                        <div className="col-12 field-mapping-header-label-wrapper">
                                            <div className="row fieldmap-table-toolbar py-1 clearfix no-gutters">
                                                <div className="ml-3 float-left">
                                                    <button className="btn" type="submit" >
                                                        <i className="fa fa-save fa-fw"></i> Apply
                                                </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <JSONForm
                                        type="text"
                                        name="integrationTransformationsJSONStr"
                                        id={integrationTransformationsJSONStr}
                                        onChange={handleChange}
                                        value={values.integrationTransformationsJSONStr}
                                        label="Transformations"
                                        allowedTypes={["Transform"]}
                                        dispatch={dispatch}
                                        hiddenFields={["type", "datasourcemapping_id", "schedule_id"]}
                                    />
                                </div>
                            )
                            // Prepare the header fields.

                            return (
                                <CSSTransition
                                    in={true}
                                    appear={true}
                                    timeout={500}
                                    classNames="fade"
                                >

                                    <div className="form-area-wrapper">
                                        <form onSubmit={e => {
                                            e.persist()
                                            e.preventDefault()

                                            if (errors && errors.hasOwnProperty("schedule")) {
                                                console.log('ERRORS',errors)
                                                this.props.dispatch(
                                                    showMessage({
                                                        type: "error",
                                                        title: "Error",
                                                        message: "There are errors in schedule, please check"
                                                    })
                                                )
                                            } else {

                                                this.setState({ fieldMappingLocked: true }, () => {
                                                    handleSubmit(e)
                                                })
                                            }
                                        }}>
                                            <div className="add-field-wrapper">
                                                <div key="btn-panel-top" className="absolute-btn">
                                                    <Link to={`/integrations/${list.id}`} className="btn">
                                                        <i className="fas fa-angle-double-left"></i> Integration
                                            </Link>
                                                    <Link to="/integrations" className="btn">
                                                        <i className="fas fa-angle-double-up"></i> Back to List
                                            </Link>
                                                </div>
                                            </div>
                                            <div className="integration-data-wrapper">
                                                <div className="integration-data-header">
                                                    <ul className="nav nav-tabs mt-1" id="integration-tab" role="tablist">
                                                        <NavItem active="active"
                                                            name="mapping"
                                                            value="Field Mapping"
                                                            selected={true}
                                                        />
                                                        <NavItem name="schedule" />
                                                      
                                                         {isUserAdmin && <NavItem name="integrationOptions" value="Options" />}
                                                         {isUserAdmin && <NavItem name="integrationTransformations" value="Transformations" />}
                                                         {!isUserAdmin && <NavItem name="integrationOptions2" value="Options" /> }
                                                      
                                                        {isUserAdmin && <NavItem name="audit" />}

                                                        {isUserAdmin && <NavItem name="executionTab" value="Execution Logs" />}
                                                            
                                                     
                                                        {/* <NavItem name="auditv2" /> */}
                                                    </ul>
                                                </div>
                                                <div className="tab-content" id="integration-tab-content">
                                                    <NavContent
                                                        content={FldMapping}
                                                        active="show active"
                                                        id="mapping"
                                                    />
                                                    <NavContent content={SchedForm} id="schedule" />
                                                    <NavContent content={IntegrationOptionForm} id="integrationOptions" />
                                                    <NavContent content={IntegrationOptionForm2} id="integrationOptions2" />
                                                    <NavContent content={IntegrationTransformationForm} id="integrationTransformations" />
                                                    <NavContent content={IntegrationAuditForm} id="audit" />
                                                    <NavContent content={JoblogAuditForm} id="executionTab" />
                                                    {/* //<NavContent content={IntegrationAuditFormv2} id="auditv2" /> */}
                                                </div>
                                            </div>
                                        </form>
                                    </div>

                                </CSSTransition>
                            )
                        }}
                    >
                    </Formik>
                </div>
            </div >
        )
    }
}

function mapStateToProps(state, ownProps) {
    let lid = ownProps.match.params.id
    let epl = ownProps.endpoint.list
    let list = epl.find(l => l.id === Number(lid))
    let integrationOptions = list && list.options ?
        JSON.parse(list.options) : {}
    let integrationOptionsJSONStr = list && list.options ? list.options : "{}"
    let integrationTransformations = list && list.transformations ?
        JSON.parse(list.transformations) : {}
    let integrationTransformationsJSONStr = list && list.transformations ? list.transformations : "{}"
    let mappingId = Number(integrationOptions.datasourcemapping_id)

    let scheduleId = integrationOptions.schedule_id
    let schedule = state.endpoints.find(endpoint => endpoint.name === 'schedules')
        .list.find(schedule => schedule.id === scheduleId)

    let isUserAdmin = state.auth.user && state.auth.user.isAdmin

    return {
        list: list,
        endpointId: ownProps.endpoint.id,
        endpointName: ownProps.endpoint.name,
        accessToken: state.auth.access_token,
        isFetching: ownProps.endpoint.isFetching,
        formType: ownProps.formType,
        parentUrl: ownProps.parentUrl,
        integrationOptions: integrationOptions,
        integrationOptionsJSONStr: integrationOptionsJSONStr,
        integrationTransformations: integrationTransformations,
        integrationTransformationsJSONStr: integrationTransformationsJSONStr,
        mappingId: mappingId,
        schedule: schedule,
        endpoints: state.endpoints,
        main: state.main,
        isUserAdmin: isUserAdmin
    }
}

export default withRouter(connect(mapStateToProps)(IntegrationMappingForm))


// WEBPACK FOOTER //
// ./src/components/integrationMappingForm.js